module.exports = __webpack_public_path__ + "static/img/jujiaimg.7a22061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/jujiaimg.png
// module id = Dvrl
// module chunks = 1